import React from 'react';
import PublicApiExzeoUpload from '../PublicApiExzeoUpload';


const FormFileUpload = (field) => {
    const { maxFileUploadSize, invalidFilesToUpload, fileUploadUrl, allowMultiple } = field;

    const onsaveAndUpdateFileCaption = (fileJson) => {
        // updateUploadedData(fileJson)
        field.input.onChange(fileJson)
    }

    return (
        <div className={`${(field.meta.touched && field.meta.error) ? 'errorMsg' : ''}`}>
            {field.label && <label>{field.label}{field.isRequired && <sup>*</sup>}
            </label>}
            <PublicApiExzeoUpload
                url={fileUploadUrl}
                maxSize={maxFileUploadSize}
                inValidFiles={invalidFilesToUpload}
                multiple={allowMultiple}
                uploadedData={field.meta.initial ? field.meta.initial :[]}
                saveAndUpdateFileCaption={onsaveAndUpdateFileCaption}
                isSingleFile={allowMultiple ? false :true}
                helpText={field.helpText}
            />
            {field.meta.touched && field.meta.error &&
                <span>{field.meta.error}</span>}
        </div>
    )
}

export default FormFileUpload;